export enum AuthKey {
    LOGIN_KEY = 'Login.currentUser',
    CURRENT_USER_KEY = 'AuthenticationService.currentUser',
    SUBSCRIPTION_KEY = 'Subscription.currentUser',
    VOD_KEY = 'VODs.currentUser',
    ANON_TOKEN = 'anon_token_key'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/auth-key.enum.ts